(function () {
	'use strict';

	angular
		.module('invesfleet')
        .factory('logEmpleadosService', logEmpleadosService);

    logEmpleadosService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

    function logEmpleadosService($http, $q, endPoints, authorization) {
        var service = {
            getPending: getPending,
            getAccepted: getAccepted,
            getActive: getActive, 
            getDriversNum: getDriversNum, 
            aprobar: aprobar, 
            archivar: archivar,
            desarchivar: desarchivar,
            getAvailable: getAvailable, 
            getAll: getAll, 
            getPendingNum: getPendingNum, 
            getById: getById, 
            getEmpleados: getEmpleados, 
            getGruposEstado: getGruposEstado, 
            save: save, 
            getAllEmpleados: getAllEmpleados, 
            suscriptionHorarioUpdate: suscriptionHorarioUpdate,
            aceptarJornadas: aceptarJornadas, 
            getJornadasEmpleado: getJornadasEmpleado, 
            rechazarJornada: rechazarJornada, 
            changeEstadoJornada: changeEstadoJornada, 
            getMyById: getMyById, 
            createZoho: createZoho, 
            updateZoho: updateZoho, 
            deleteZoho: deleteZoho, 
            getZoho: getZoho, 
            getArchivadas: getArchivadas
		};

		return service;

        function getPending() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.logEmpleados.getPending,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

        function getArchivadas() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.logEmpleados.getArchivadas,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

        function getJornadasEmpleado() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.logEmpleados.getJornadasEmpleado,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

        function getZoho(empmasterId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.logEmpleados.getZoho +'?empresaMasterId='+empmasterId,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

        function deleteZoho(subId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.logEmpleados.deleteZoho,
                data: {
                    subscriptionId: subId
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        
        function updateZoho(subId, emp) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.logEmpleados.updateZoho,
                data: {
                    subscriptionId: subId,
                    employeeCount: emp
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function createZoho(empmasterId, emp) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.logEmpleados.createZoho +'?empresaMasterId=' + empmasterId,
                data: {
                    planCode: 'ESTANDAR_RRHH_MEN',
                    employeeCount: emp
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

         function getDriversNum() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getDriversNum,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

         function getEmpleados() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getEmpleados,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

         function getAllEmpleados() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getAllEmpleados,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

         function getGruposEstado() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getGruposEstado,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

         function getById(id) {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getById + '?id=' + id,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

          function getMyById(id) {
              var deferred = $q.defer();
              var request = {
                  method: 'GET',
                  url: endPoints.logEmpleados.getMyById + '?id=' + id,
              };
              authorization.setBearerHeader($http);
              $http(request).then(function (response) {
                      deferred.resolve(response.data);
                  },
                  function (response) {
                      deferred.reject(null);
                  });
              return deferred.promise;

          }

         function getPendingNum() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.logEmpleados.getPendingNum,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response.data);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;

         }

          function getActive() {
              var deferred = $q.defer();
              var request = {
                  method: 'GET',
                  url: endPoints.logEmpleados.getActive,
                 
              };
              authorization.setBearerHeader($http);
              $http(request).then(function (response) {
                      deferred.resolve(response);
                  },
                  function (response) {
                      deferred.reject(null);
                  });
              return deferred.promise;
          }

          function getAvailable() {
              var deferred = $q.defer();
              var request = {
                  method: 'GET',
                  url: endPoints.logEmpleados.getAvailable,

              };
              authorization.setBearerHeader($http);
              $http(request).then(function (response) {
                      deferred.resolve(response);
                  },
                  function (response) {
                      deferred.reject(null);
                  });
              return deferred.promise;
          }

           function aceptarJornadas(jornadas) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.aceptarJornadas,
                   data: jornadas
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

           function rechazarJornada(id, motivo) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.rechazarJornada,
                   data : {
                        id: id,
                        motivo: motivo
                   }
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

           function changeEstadoJornada(val) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.changeEstadoJornada,
                   data: val
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

           function aprobar(jornadas, resumenes = []) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.aprobar,
                   data: {
                       Resumenes: resumenes,
                       Jornadas: jornadas,
                   }
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

            function archivar(jornada) {
                var deferred = $q.defer();
                var request = {
                    method: 'POST',
                    url: endPoints.logEmpleados.archivar,
                    data: {
                        jornada: jornada,
                    }
                };
                authorization.setBearerHeader($http);
                $http(request).then(function (response) {
                        deferred.resolve(response);
                    },
                    function (response) {
                        deferred.reject(null);
                    });
                return deferred.promise;
            }

            function desarchivar(jornada) {
                var deferred = $q.defer();
                var request = {
                    method: 'POST',
                    url: endPoints.logEmpleados.desarchivar,
                    data: {
                        jornada: jornada,
                    }
                };
                authorization.setBearerHeader($http);
                $http(request).then(function (response) {
                        deferred.resolve(response);
                    },
                    function (response) {
                        deferred.reject(null);
                    });
                return deferred.promise;
            }

            function suscriptionHorarioUpdate(accion, list, numLic, supervisorId) {
                var deferred = $q.defer();
                var request = {
                    method: 'POST',
                    url: endPoints.logEmpleados.suscriptionHorarioUpdate,
                    data: {
                        accion: accion,
                        list: list,
                        numLic: numLic, 
                        supervisorId: supervisorId
                    }
                };
                authorization.setBearerHeader($http);
                $http(request).then(function (response) {
                        deferred.resolve(response);
                    },
                    function (response) {
                        deferred.reject(null);
                    });
                return deferred.promise;
            }


           function save(modificaciones, observaciones, id) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.save,
                   data: {
                       modificaciones: modificaciones,
                       observaciones: observaciones, 
                       id: id
                   }
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

           function getAccepted(date, id, type) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.getAccepted,
                    data: {
                        date: date,
                        empleado: id
                    }
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }

           //unused
           function getAll(date, id) {
               var deferred = $q.defer();
               var request = {
                   method: 'POST',
                   url: endPoints.logEmpleados.getAll,
                   data: {
                       date: date,
                       empleado: id
                   }
               };
               authorization.setBearerHeader($http);
               $http(request).then(function (response) {
                       deferred.resolve(response);
                   },
                   function (response) {
                       deferred.reject(null);
                   });
               return deferred.promise;
           }
	}

})();